export default __webpack_public_path__ + "static/media/SourceSansPro-Regular.358e8828.ttf";